import React from 'react';
import SIcon from './SIcon';
import { faTrashUndo } from '@fortawesome/pro-light-svg-icons';

const Icon = props => <SIcon {...props} icon={faTrashUndo} fa />;

export default Icon;
